export default "__VITE_ASSET__BMHGiEI___"